import { IComponentChildrenProps } from '@src/models/props';
import React, { FC } from 'react';
import { CSSTransition } from 'react-transition-group';
import { CSSTransitionClassNames } from 'react-transition-group/CSSTransition';
import { TRANSITION_CLASSES, TRANSITION_TIMEOUT } from './consts';

export interface ITransitionClasses extends CSSTransitionClassNames {}

interface IProps<T> extends IComponentChildrenProps {
  open?: boolean;
  timeout?: number;
  transitionClasses?: ITransitionClasses;
  unmountOnExit?: boolean;
  mountOnEnter?: boolean;
  onEnter?: (elem?: T) => void;
  onEntering?: (elem?: T) => void;
  onEntered?: (elem?: T) => void;
  onExit?: (elem?: T) => void;
  onExiting?: (elem?: T) => void;
  onExited?: (elem?: T) => void;
}

/**
 * Обертка для работы с анимациями у компонентов
 * В основе лежит CSSTransition {@link https://www.npmjs.com/package/react-transition-group}.
 *
 * Оберните нужный вам компонент и управляйте стилями через колбеки `onEnter`, `onExit` и т.д.
 * Скорость анимации задается через свойство  - `timeout`, а так же через определение стилей в файлах `.scss`.
 * В обычных случаях эти параметры должны `совпадать`
 */
export const Animation: FC<IProps<HTMLElement>> = ({
  open,
  transitionClasses = TRANSITION_CLASSES,
  timeout = TRANSITION_TIMEOUT,
  ...rest
}) => {
  return <CSSTransition appear in={open} timeout={timeout} classNames={transitionClasses} {...rest} />;
};
